import { useMutation, useQuery, UseQueryOptions } from '@tanstack/react-query';
import { queryClient } from 'providers/AllProviders';
import { activateBusinessAddon, cancelBusinessAddon, getBusinessAddons, reverseBusinessAddonCancellation } from './api';
import { CancelBusinessAddonPayload } from './types';
import { MetaApiResponse } from 'utils/types/CommonApiResponse';

export const BUSINESS_ADDONS_QUERY_KEY = ['business_addons'];

type BusinessAddonsResponse = {
  data: import('./types').BusinessAddon[];
  meta?: MetaApiResponse;
};

export function useGetBusinessAddons(options?: UseQueryOptions<BusinessAddonsResponse, Error>) {
  return useQuery<BusinessAddonsResponse>({
    queryKey: BUSINESS_ADDONS_QUERY_KEY,
    queryFn: getBusinessAddons,
    ...options
  });
}

export function useActivateBusinessAddon() {
  return useMutation({
    mutationFn: (code: string) => activateBusinessAddon(code),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: BUSINESS_ADDONS_QUERY_KEY,
        refetchType: 'active'
      });
    }
  });
}

export function useCancelBusinessAddon() {
  return useMutation({
    mutationFn: ({ code, payload }: { code: string; payload: CancelBusinessAddonPayload }) =>
      cancelBusinessAddon(code, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: BUSINESS_ADDONS_QUERY_KEY,
        refetchType: 'active'
      });
    }
  });
}

export function useReverseBusinessAddonCancellation() {
  return useMutation({
    mutationFn: (code: string) => reverseBusinessAddonCancellation(code),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: BUSINESS_ADDONS_QUERY_KEY,
        refetchType: 'active'
      });
    }
  });
}
